/**
 * 标准化基础路径，确保以 '/' 开头且不包含 trailing slash
 * @param basePath 原始基础路径
 * @returns 标准化后的基础路径
 */
export function normalizeBasePath(basePath: string): string {
  const normalizedBasePath = basePath.startsWith('/')
    ? basePath
    : `/${basePath}`;
  const basePathWithoutTrailingSlash = normalizedBasePath.endsWith('/')
    ? normalizedBasePath.slice(0, -1)
    : normalizedBasePath;
  return basePathWithoutTrailingSlash;
}
